import React from 'react';
import { formatNumber, formatPercent } from '../utils/adminMetrics';

function AdminBarChart({
  title,
  items = [],
  axisLabel,
  selectedValue,
  onSelect,
  emptyMessage = 'No data available',
  showPercent = false,
}) {
  const maxCount = Math.max(...items.map((item) => item.count || 0), 0);

  if (!items.length || maxCount === 0) {
    return (
      <section className="admin-chart-card">
        <h3 className="admin-chart-title">{title}</h3>
        <p className="admin-chart-empty">{emptyMessage}</p>
      </section>
    );
  }

  return (
    <section className="admin-chart-card">
      <h3 className="admin-chart-title">{title}</h3>
      <ul className="admin-hbar-list">
        {items.map((item) => {
          const selected = selectedValue === item.value;
          const width = Math.max(4, ((item.count || 0) / maxCount) * 100);
          const valueText = showPercent
            ? formatPercent(item.percent)
            : formatNumber(item.count);
          const titleText = showPercent
            ? `${item.label}: ${formatNumber(item.count)} occurrences • ${formatPercent(item.percent)}`
            : `${item.label}: ${formatNumber(item.count)}`;
          return (
            <li key={item.value}>
              <button
                type="button"
                className={`admin-hbar-row ${selected ? 'is-selected' : ''} ${selectedValue && !selected ? 'is-dimmed' : ''}`}
                onClick={() => onSelect(item.value)}
                aria-pressed={selected}
                title={titleText}
              >
                <span className="admin-hbar-label">{item.label}</span>
                <span className="admin-hbar-track">
                  <span className="admin-hbar-fill" style={{ width: `${width}%` }} />
                </span>
                <span className="admin-hbar-value">{valueText}</span>
              </button>
            </li>
          );
        })}
      </ul>
      {axisLabel && <div className="admin-chart-axis">{axisLabel}</div>}
    </section>
  );
}

export default AdminBarChart;
